import Cookies from 'universal-cookie';

const {TransactionsClient} = require("../vendor/client/transactions");
const cookies = new Cookies();
const sessionKey = cookies.get('kjd_session');

const client = new TransactionsClient({sessionKey: sessionKey});

export default client;
